import React, { useContext } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  DialogContentText,
} from '@mui/material';
import { useModal } from 'components/Modals';
import { useForm } from 'react-hook-form';
import { findOnArray } from 'utils/functions';
import { DropsContext } from 'contexts/DropsContext';
import { GridContext } from 'contexts/GridContext';
import VirtualDrop from 'components/VirtualDrop';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';

const AddModal = ({ onSubmit, funcionario_id }) => {
  const defaultValues = {
    rotina: 'Pessoal',
    funcionario_id,
    empregador_id: null,
    estabelecimento_id: null,
    categoria_trabalhador_id: null,
  };
  const { closeModal } = useModal();
  const { control, handleSubmit } = useForm({ defaultValues });
  const { postLoading } = useContext(GridContext);
  const { drops } = useContext(DropsContext);

  return (
    <>
      <DialogTitle>Adicionar Vínculo</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} textAlign="center">
            <DialogContentText>
              {findOnArray(funcionario_id, drops?.Entidade, 'label')}
            </DialogContentText>
          </Grid>
          <Grid item xs={12} sm={4}>
            <VirtualDrop
              control={control}
              label="Empregador"
              name="empregador_id"
              options={drops?.Entidade}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <VirtualDrop
              control={control}
              label="Estabelecimento"
              name="estabelecimento_id"
              options={drops?.Entidade}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Dropdown
              control={control}
              name="categoria_trabalhador_id"
              label="Categoria do Trabalhador"
              options={drops?.CategoriaTrabalhador}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit(onSubmit)} loading={postLoading}>
          Confirmar
        </Button>
        <Button onClick={closeModal} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default AddModal;
